import { once } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import * as TrackingConstants from '../../EventTrackingConstants';
import { LOCALIZED_STRINGS } from './constants';
import LocationCardCarouselView from './view';

export default class LocationCardCarouselContainer extends React.Component {
    static propTypes = {
        animationNextLocationId: PropTypes.string,
        callbackAfterAnimationCompletes: PropTypes.func,
        clickNext: PropTypes.func.isRequired,
        clickNextAnimationStart: PropTypes.func.isRequired,
        clickPrev: PropTypes.func.isRequired,
        clickPrevAnimationStart: PropTypes.func.isRequired,
        insuranceIsAccepted: PropTypes.bool,
        isTrackingInsuranceStatus: PropTypes.bool,
        locationId: PropTypes.string,
        locations: PropTypes.arrayOf(PropTypes.object),
        onClickExpandMap: PropTypes.func,
        section: PropTypes.string.isRequired,
        showMapThumbnail: PropTypes.bool,
        trackInsuranceStatusUpdate: PropTypes.func.isRequired,
    };

    static defaultProps = {
        locations: [],
        showMapThumbnail: true,
    };

    state = {};

    componentDidUpdate(prevProps) {
        const {
            section,
            insuranceIsAccepted,
            insuranceIsSelected,
            trackInsuranceStatusUpdate,
        } = prevProps;

        if (section === TrackingConstants.TARGETS.BOOK_AN_APPOINTMENT
            && insuranceIsSelected
            && insuranceIsAccepted !== this.props.insuranceIsAccepted) {
            if (typeof this.props.insuranceIsAccepted === 'undefined') {
                trackInsuranceStatusUpdate(LOCALIZED_STRINGS.CheckingInsurance.defaultMessage);
            } else if (this.props.insuranceIsAccepted) {
                trackInsuranceStatusUpdate(LOCALIZED_STRINGS.InsuranceAccepted.defaultMessage);
            } else {
                trackInsuranceStatusUpdate(LOCALIZED_STRINGS.InsuranceNotAccepted.defaultMessage);
            }
        }
    }

    render() {
        return (
            <div>{this.maybeRenderView()}</div>
        );
    }

    maybeRenderView() {
        const {
            locations,
            locationId,
            insuranceIsAccepted,
            onClickExpandMap,
            showMapThumbnail,
            animationNextLocationId,
            callbackAfterAnimationCompletes,
            insuranceIsSelected,
        } = this.props;

        if (locations && locations.length > 0) {
            const selectedLocationId = locationId || locations[0].id;
            return (
                <LocationCardCarouselView
                    animationNextLocationId={animationNextLocationId || locationId || locations[0].id}
                    callbackAfterAnimationCompletes={callbackAfterAnimationCompletes}
                    insuranceIsAccepted={insuranceIsAccepted}
                    insuranceIsSelected={insuranceIsSelected}
                    locationId={selectedLocationId}
                    locations={locations}
                    onClickExpandMap={onClickExpandMap}
                    onClickNext={this.onClickNextAnimationStart}
                    onClickPrev={this.onClickPrevAnimationStart}
                    showMapThumbnail={showMapThumbnail}
                />
            );
        }
    }

    getPrevLocation = () => {
        const { locations, locationId } = this.props;

        const currentLocationIndex = locations.findIndex(loc => loc.id === locationId);
        const prevLocationIndex = ((currentLocationIndex - 1) + locations.length) % locations.length;
        return locations[prevLocationIndex].id;
    };

    getNextLocation = () => {
        const { locations, locationId } = this.props;

        const currentLocationIndex = locations.findIndex(loc => loc.id === locationId);
        const nextLocationIndex = (currentLocationIndex + 1) % locations.length;
        return locations[nextLocationIndex].id;
    };

    onClickPrevAnimationStart = () => {
        this.props.clickPrevAnimationStart(this.getPrevLocation(), once(this.onClickPrev));
    };

    onClickNextAnimationStart = () => {
        this.props.clickNextAnimationStart(this.getNextLocation(), once(this.onClickNext));
    };

    onClickPrev = () => {
        this.props.clickPrev(this.getPrevLocation());
    };

    onClickNext = () => {
        this.props.clickNext(this.getNextLocation());
    };
}
